<template>
	<div class="layout-input" :class="{disabled}">
		<slot/>

		<div class="unit" v-if="unit" v-text="unit"/>
	</div>
</template>

<script>
export default {
	props: {
		disabled: {type: Boolean, required: false},
		unit: {type: String, required: false}
	}
};
</script>

<style lang="scss" scoped>
.layout-input {
	position: relative;

	&.disabled {

		/deep/ .input {
			color: #B1B1B1;

			@include placeholder {
				color: #B1B1B1;
			}
		}
	}

	/deep/ .input {
		appearance: none;
		background-color: #F5F5F5;
		border: 1px solid #E2E2E2;
		border-radius: 2px;
		height: 38px;
		width: 100%;
		padding: 0 16px;
		outline: none;
		font-weight: 400;
		display: flex;
		align-items: center;

		@include placeholder {
			color: #182E38;
		}
	}

	.unit {
		font-size: 11px;
		color: #B1B1B1;
		position: absolute;
		right: 1em;
		top: 0;
		bottom: -2px;
		display: flex;
		align-items: center;
	}
}
</style>
